import { render } from "./SignUpModal.vue?vue&type=template&id=e38a96c4&scoped=true"
import script from "./SignUpModal.vue?vue&type=script&lang=js"
export * from "./SignUpModal.vue?vue&type=script&lang=js"

import "../../../assets/css/Modals/AuthenticationModals/SignUpModal.css?vue&type=style&index=0&id=e38a96c4&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38a96c4"]])

export default __exports__